/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-02-05 13:55:32
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-02-05 18:26:52
 * @FilePath: \maxima\src\locales\vi-VN.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  message: {
    langSelect: "Lựa chọn ngôn ngữ",
    injoin: 'injoinUS.png',
    GoldPass: 'GoldPass',
    JoinNow: 'Tham gia',
    MyEarningsM: 'Airdrop của tôi/MAX',
    MyEarningsU: 'Ra nhiều lần',
    Participated: 'Không liên quan',
    SilverPass: 'SilverPass',
    MyParticipation: 'Sự tham gia của tôi',
    PromotionU: 'Tổng số tiền mua/USDT',
    AmountUSDT: 'Công bằng/USDT',
    HashpowerMultiplier: 'Bội số vốn chủ sở hữu',
    Earnings: 'Thu nhập',
    available: 'Hiện chưa có nội dung',
    EarningsUSDT: 'Thu nhập Khuyến mãi/USDT',
    Cumulative: "Tổng thu nhập từ Khuyến mãi/USDT",
    Time: 'Thời gian',
    Type: 'Loại',
    Amount: 'Số tiền',
    Source: 'Nguồn',
    Promotion: 'Khuyến mãi',
    GiftMAX: "Quà token/MAX",
    TotalCumulativMAX: 'Quà token đã tích luỹ/MAX',
    Gift: 'Quà tặng',
    Orders: 'Đơn hàng',
    Invitations: 'Mời',
    ofInvitations: "Số lượng người mời (cá nhân)",
    Participate: "Tham gia",
    SelectType: "Chọn Thẻ Xanh",
    Due: 'Phải thanh toán',
    AmountPaid: 'Đã thanh toán',
    AddOrder: 'Thêm Đơn hàng',
    ConfirmPayment: "Xác nhận Thanh toán",
    ParticipationOptions: 'Tùy chọn Tham gia',
    OrderInformation: 'Thông tin Đơn hàng',
    USDTTransfer: 'Chuyển USDT',
    PaymentMethod: 'Phương thức thanh toán',
    MaximaWalletBalance: 'Số dư Ví Maxima',
    PayNow: 'Thanh toán Ngay',
    FriendlyReminder: 'Lời nhắc',
    Cancelpayment: 'Tôi có nên tiếp tục sau khi khoản thanh toán không thể hủy ngang không?',
    Cancel: 'Bỏ ',
    ContinuePayment: 'Tiếp tục Thanh toán',
    InsufficientBalance: 'Số dư không đủ',
    toMaximaWallet: 'Vui lòng chuyển USDT vào Ví Maxima',
    ReturntoHomepage: 'Quay lại Trang chủ',
    Gotit: 'Đã hiểu',
    PaymentSuccessful: 'Thanh toán thành công',
    Confirm: 'Xác nhận',
    PaymentFailed: 'Thanh toán thất bại',
    lackNum: 'Bạn đã vượt quá tổng số 100 mục nhập',
    Share: 'Phần',
    NoMore: 'Không còn nữa'
  }
}
